const board = {
    mainSlideCode: '000',
    bannerCode: '006',
    eventBannerCode: '007',
    noticeNo: 206343
}

export default board;